<script>
  import { Bar } from 'vue-chartjs';
  import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
  import { hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities';
  import {isEmpty} from "@/utils/fileHelper";

  export default {
    name: "BarCharts",
    components: {
      hexToRgba,
      CustomTooltips
    },
    props: [
      'datas',
      'height',
      'width',
    ],
    extends: Bar,
    data () {
      return {
        isEmpty
      }
    },
    mounted () {
      let dataSets = [];
      let labels = [];
      if (!isEmpty(this.datas)) {
        labels = this.datas.labels
        for (let data of this.datas.datas) {
          dataSets.push({
            label: data.label,
            backgroundColor: hexToRgba(data.backgroundColor, 90),
            data: data.data
          });
        }
      } else {
        dataSets = [{label: '', backgroundColor: '#FFFFFF', data: []}];
      }
      
      function getMin() {
        return dataSets.reduce((res, set) => {
          return res !== null && res < Math.min(...set.data) ? res : Math.min(...set.data);
        }, null);
      }

      function getMax() {
        return dataSets.reduce((res, set) => {
          return res !== null && res > Math.max(...set.data) ? res : Math.max(...set.data);
        }, null);
      }

      this.renderChart(
        {
          labels: labels,
          datasets: dataSets
        },
        {
          responsive: true,
          height: '50%',
          maintainAspectRatio: false,
          tooltips: {
            enabled: false,
            custom: CustomTooltips,
            intersect: true,
            mode: 'index',
            position: 'nearest',
            callbacks: {
              labelColor: function (tooltipItem, chart) {
                
                return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }
              },
              label: function (context,chart) {
                let label = chart.datasets[context.datasetIndex].label || '';

                if (label) {
                    label += ': ';
                }
                if (context.value !== null) {
                    label += context.value + ' dossiers';
                }
                return label;
              },
            }
          },
          scales: {
          xAxes: [
              {
                gridLines: {
                  lineWidth: 1,
                  borderDash: []
                  // zeroLineColor: 'transparent'
                },
                // ticks: {
                //   fontSize: 2,
                //   fontColor: 'transparent'
                // }
              }
            ],
            yAxes: [
              {
                display: true,
                ticks: {
                  callback: function(val, index) {
                    // Hide every 2nd tick label
                    return index % 2 === 0 ? val : '';
                  },
                  display: true,
                  min: (getMin() - 4) > 0 ? getMin() - 4 : 0,
                  max: getMax(),
                  // callback: function(value, index, ticks) {
                  //   console.log('dans callback', value, index, ticks)
                  //   return value + ' jours';
                  // }
                }
              }
            ]
          },
        }
      )
    }
  }
</script>
